function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useEffect, useContext } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { actions as ppcActions } from '../../../reducers/ppc.reducer';
import useHasPermission from '../../../helpers/hooks/useHasPermission';
import ServiceDetailsData from '../ServiceDetails.context';
import Card from '../../common/card/Card.react';
import CardHeader from '../../common/card/CardHeader.react';
import Table from '../../common/table/Table.react';
var PpcServiceCategory = function PpcServiceCategory() {
  var dispatch = useDispatch();
  var _useParams = useParams(),
    app = _useParams.app,
    serviceID = _useParams.serviceID;
  var ppcServiceCategory = useSelector(function (s) {
    return s.ppc.service.category;
  });
  var hasPermission = useHasPermission("edit-".concat(app, "-services"));
  var _useContext = useContext(ServiceDetailsData),
    _useContext2 = _slicedToArray(_useContext, 1),
    state = _useContext2[0];
  var _useState = useState({
      columns: {},
      data: []
    }),
    _useState2 = _slicedToArray(_useState, 2),
    tableData = _useState2[0],
    setTableData = _useState2[1];
  var serviceCategory = state.serviceCategory,
    archived = state.archived;
  useEffect(function () {
    dispatch({
      type: ppcActions.serviceCategory,
      payload: {}
    });
  }, []);
  var isIncluded = function isIncluded(categoryID) {
    return serviceCategory === null || serviceCategory === void 0 ? void 0 : serviceCategory.find(function (x) {
      return x._id === categoryID;
    });
  };
  useEffect(function () {
    if (!ppcServiceCategory) return;
    var data = [];
    Object.values(ppcServiceCategory).filter(function (x) {
      return !x.archived;
    }).filter(function (x) {
      return x.clientApp === app;
    }).forEach(function (x) {
      data.push({
        _id: x._id,
        title: x.title,
        included: isIncluded(x._id) ? true : false
      });
    });
    setTableData({
      columns: {
        id: {
          title: '_id',
          visible: false
        },
        title: 'Title',
        included: {
          title: 'Included',
          size: 'contain',
          onClick: function onClick(_ref) {
            var row = _ref.row;
            if (archived || !hasPermission) return;
            dispatch({
              type: ppcActions.service,
              payload: {
                formData: {
                  serviceID: serviceID,
                  categoryID: row._id
                },
                method: !row.included ? 'put' : 'delete',
                route: 'service-category'
              }
            });
          }
        }
      },
      data: data
    });
  }, [serviceCategory, ppcServiceCategory]);
  return /*#__PURE__*/React.createElement("div", {
    className: "page__content--block"
  }, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardHeader, {
    title: "Categories"
  }), /*#__PURE__*/React.createElement(Table, _extends({}, tableData, {
    filterColumns: ['title'],
    sort: {
      by: 'title'
    }
  }))));
};
export default PpcServiceCategory;